import React from 'react';
import MultiStepTraderRegistration from '../components/forms/MultiStepTraderRegistration';

/**
 * TraderRegistration View - Multi-Step Registration Process
 * 
 * This component provides an improved user experience by dividing the registration
 * process into three logical stages:
 * Stage 1: Basic Information (Company name, owner name, email, password)
 * Stage 2: Business Details (Business type, location, phone)
 * Stage 3: Company Profile (Logo, description, optional website)
 */
const TraderRegistration: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100">
      {/* Header with navigation */}

      {/* Multi-step registration component */}
      <MultiStepTraderRegistration />

      {/* Footer with login link */}
    </div>
  );
};

export default TraderRegistration;
